import { UseMutateAsyncFunction, useMutation } from 'react-query';

import {
  ClientLoginWithCodeRequestType,
  ClientLoginWithCodeResponseType
} from '../../../services/FormsAuthServices/APIService/types';

import { useFormsAuthAPIService } from '../useFormsAuthAPIService';

function useGetFormsAuthClientAuthDetails(): {
  getFormsAuthClientAuthDetailsAPI: UseMutateAsyncFunction<
    ClientLoginWithCodeResponseType,
    unknown,
    ClientLoginWithCodeRequestType,
    unknown
  >;
  error;
  status;
} {
  const { formsAuthAPIService } = useFormsAuthAPIService();

  const getAuthDetails = (requestObject: ClientLoginWithCodeRequestType) => {
    return formsAuthAPIService.onLogin(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(getAuthDetails, {
    mutationKey: ['getFormsAuthClientAuthDetails']
  });

  return {
    getFormsAuthClientAuthDetailsAPI: mutateAsync,
    error,
    status
  };
}

export { useGetFormsAuthClientAuthDetails };
